/*jshint esversion: 6 */
var Geocoder = (function(){
  'use strict';

  var params = ['housenumber', 'street', 'city'];

  var isFunction = function (f) {
    return f && {}.toString.call(f) === '[object Function]';
  };

  var formatAddress = function (data) {
    var address = '';
    params.forEach( function (p) {
      if (data[p] && data[p] != null) {
        if (data['type'] == 'city' && p === 'city') { //Cas d'une commune ou arrondissement
          address = data[p];
        } else {
          if (p === 'city') {
            address = address.trim() + ', ';
          }
          address += data[p] + ' ';
          if (p === 'name' && (data.housenumber || data.street)) {
            address += '- ';
          }
        }
      }
    });

    return address.trim();
  };

  var geocode = function(adresse, callbackFn, bbox = '', usePhotonBal = 0) {
    var url = CACHE_URL + '/geocoder?action=geocode&limit=5&q=' + adresse.trim() + '&photonBal=' + usePhotonBal;

    if (bbox) {
      url += '&bbox=' + bbox;
    }

    var request = new XMLHttpRequest();

    request.open('GET', url, true);
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {

        if (request.responseText !== "") {
          var data = JSON.parse(request.responseText);
          let returnData = {};

          if (data.features[0]) {
            returnData = {
                'data': data,
                'lat': data.features[0].geometry.coordinates[1],
                'lng': data.features[0].geometry.coordinates[0]
              };
          } else {
            returnData = {
                'data': data,
                'lat': '',
                'lng': ''
              };
          }

          if (isFunction(callbackFn)) {
            callbackFn(returnData);
          }
        }
      }
    };

    request.send();
  };

  var reverseGeocode = function(lngLat, callbackFn, usePhotonBal = 0) {
    var url = CACHE_URL + '/geocoder?action=reverse&lon=' + lngLat[0] + '&lat='+lngLat[1] + '&photonBal=' + usePhotonBal;
    var request = new XMLHttpRequest();

    request.open('GET', url, true);
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        var data = JSON.parse(request.responseText);

        if (data.features[0]) {
          var address_data = data.features[0].properties;
          var address = formatAddress(address_data);

          if (isFunction(callbackFn)) {
            callbackFn({'adresse': address, 'data': address_data});
          }
          else {
            return address_data;
          }
        }
      }
    };

    request.send();
  };

  return {
    geocode: geocode,
    reverseGeocode: reverseGeocode,
    formatAddress: formatAddress
  };

}());
